import React, { useState, useEffect, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { getEndUserDetails, setDefaultBank } from '../api';
import { bankpay_consumer_user_id } from '../common/constants';
import { getLocalStorageData } from '../common/resubale-functions';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Images } from '../assets';
import { GoBack } from '../components/back-button';
import { MainContext } from '../components/context/context';

const Account = () => {
  const context = useContext(MainContext);
  const { path, setPath } = context;
  const user_id = getLocalStorageData(bankpay_consumer_user_id, 'string');
  const [allBanks, setAllBanks] = useState([]);
  useEffect(() => {
    getuserDetails();
  }, []);
  useEffect(() => {
    setPath(window.location.pathname);
  }, [window.location.pathname]);

  const getuserDetails = async () => {
    const res = await getEndUserDetails(user_id);
    setAllBanks(res?.data?.data);
  };
  const handleSelectBank = async (id) => {
    try {
      const res = await setDefaultBank(user_id, { default_bank: id });
      if (res.data.code == 200) getuserDetails();
    } catch (e) {
      toast.error('SomeThing Went Wrong');
    }
  };
  return (
    <div>
      <GoBack />
      {allBanks?.banks?.length ? (
        <>
          <p className='bp_checkout-linked-bank-text'>Linked accounts</p>
          {allBanks?.banks?.map((bank) => (
            <Row
              className='bp_checkout-banks-box'
              onClick={() => handleSelectBank(bank?.id)}
            >
              <Col xs='10' className='py-2 bp_checkout-bank-list'>
                {bank?.logo_url ? (
                  <img src={bank?.logo_url} alt='' />
                ) : (
                  <div className='bank-name-card'>
                    {bank?.institution_id?.substring(0, 3)}
                  </div>
                )}
                <span className='bp_checkout-bank-names'>
                  {bank?.institution_id}
                </span>
              </Col>
              <Col xs='2' className='selected-bank'>
                {allBanks?.default_bank == bank?.id
                  ? 'Default'
                  : 'Make Default'}
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <p className='bp_checkout-linked-bank-text'>No Linked accounts</p>
      )}
    </div>
  );
};

export default Account;
